import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    id_ciudad: null,
    form_ciudad: {
        derechos_traspaso: 0,
        levantamiento_prenda: 0,
        certificado_tradicion: 0,
        pignoracion: 0,
        honorarios: 0
    }, 
};
const mutations = {
    updateField
};
const getters = {
    getField
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
